<script setup lang="ts">
import { onMounted } from 'vue';
import { FormList } from '@/components/forms/';
import { useFormStore } from '@/stores/forms';

const formStore = useFormStore();

onMounted(async () => {
  await formStore.getStudyForms();
});
</script>

<template>
  <div class="form-container"><FormList /></div>
</template>

<style scoped lang="scss">
.form-container {
  height: 100%;
}
</style>
